module.exports = __webpack_public_path__ + "img/heavy_armor_3.fae8c473.png";